import { Box, Divider, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

import { UploadButtonComponent } from "@/components/ImageUpload";
import { StyledModal } from "@/components/StyledModal";
import theme from "@/theme";

const useStyles = makeStyles(() => ({
  messageContent: {
    padding: "24px 24px 0 24px",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "center",
    borderTop: `1px solid ${theme.palette.semantic["border/strong"]}`,
    alignItems: "center",
    height: 60,
  },
  button: {
    minWidth: 100,
  },
  description: {
    textAlign: "center",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  link: {
    textDecoration: "none",
    cursor: "pointer",
    textAlign: "center",
    "&:hover": {
      borderBottom: "none",
    },
  },
  divider: {
    height: "100%",
    backgroundColor: theme.palette.divider,
    margin: "0 16px",
  },
}));

interface ChangePropertyImageModalProps {
  open: boolean;
  onClose: () => void;
  onClickChangeImage: (_file: File) => Promise<void>;
}

export const ChangePropertyImageModal: React.FC<ChangePropertyImageModalProps> = ({
  open,
  onClose,
  onClickChangeImage,
}) => {
  const classes = useStyles();
  const [postImageData, setPostImageData] = React.useState<File>(null);

  const handleClickOutside = React.useCallback(() => {
    document.body.style.overflow = "auto"; // Enable scrolling
    onClose();
  }, [onClose]);

  const handleChangeUploadFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }
    setPostImageData(file);
    event.target.value = "";
  };

  // スクロール制御
  React.useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden"; // Disable scroll when modal is open
      return () => {
        document.body.style.overflow = "auto"; // Enable scroll when modal is closed
      };
    }
  }, [open]);

  const handleUpdateImage = React.useCallback(() => {
    onClickChangeImage(postImageData);
  }, [postImageData, onClickChangeImage]);

  if (!open) return null;

  return (
    <StyledModal onClickOutside={handleClickOutside}>
      <Box className={classes.messageContent}>
        <Box textAlign="center" mb={2}>
          <Typography variant="h3">画像を選択してください</Typography>
        </Box>
        <Box my={2} display="flex" justifyContent="center">
          <UploadButtonComponent name="property_image" handleFileChange={handleChangeUploadFile} />
        </Box>
      </Box>
      <Box className={classes.buttonContainer}>
        <Typography
          variant="button"
          color="textPrimary"
          className={`${classes.link} ${classes.button}`}
          onClick={onClose}
        >
          キャンセル
        </Typography>
        <Divider orientation="vertical" flexItem className={classes.divider} />
        <Typography
          variant="button"
          color="error"
          className={`${classes.link} ${classes.button}`}
          onClick={handleUpdateImage}
        >
          変更する
        </Typography>
      </Box>
    </StyledModal>
  );
};
